import { useTranslation } from 'react-i18next';

import {
  amountValueStyle,
  containerStyle,
  contentStyle,
  incomeAmountStyle,
  outcomeAmountStyle,
  subtitleStyle,
  timestampStyle,
  titleStyle,
  titleWrapperStyle
} from './styles';

import { ITonTransaction } from '@/api/ton/types.ts';
import { helpers } from '@/helpers.ts';
import {
  TonTransactionSources,
  TonTransactionStates,
  TonTransactionTypes
} from '@/enums/apiEnums.ts';
import IncomeShape from '@/components/common/svg/shapes/IncomeShape.tsx';
import OutcomeShape from '@/components/common/svg/shapes/OutcomeShape.tsx';

interface TonTransactionProps {
  tonTransactionData: ITonTransaction;
}

const TonTransaction = ({ tonTransactionData }: TonTransactionProps) => {
  const { i18n, t } = useTranslation();
  const isIncome = tonTransactionData.type === TonTransactionTypes.TYPE_INCOME;

  const formatTransactionDate = (date: string): string =>
    new Date(date.replace(' ', 'T')).toLocaleDateString(i18n.language, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

  const getTypeTranslation = (type: TonTransactionTypes): string => {
    if (type === TonTransactionTypes.TYPE_INCOME)
      return t('earn.transaction.income');
    if (type === TonTransactionTypes.TYPE_WITHDRAWAL)
      return t('earn.transaction.withdrawal');
    return '';
  };

  const getSourceTranslation = (source?: TonTransactionSources): string => {
    if (source === TonTransactionSources.SOURCE_CHALLENGE_REWARD)
      return t('earn.transaction.source_challenge_reward');
    if (source === TonTransactionSources.SOURCE_ACTIVITY_REWARD)
      return t('earn.transaction.source_activity_reward');
    return '';
  };

  const getStateTranslation = (state?: TonTransactionStates): string => {
    if (state === TonTransactionStates.STATE_PENDING)
      return t('earn.transaction.state.pending');
    if (state === TonTransactionStates.STATE_APPROVED)
      return t('earn.transaction.state.approved');
    if (state === TonTransactionStates.STATE_REJECTED)
      return t('earn.transaction.state.rejected');
    return '';
  };

  const type = getTypeTranslation(tonTransactionData.type);
  const source = getSourceTranslation(tonTransactionData.source);
  const state = getStateTranslation(tonTransactionData.state);
  const amount = helpers.convertMicrosToTON(tonTransactionData.ton_micros);

  return (
    <div style={containerStyle}>
      {isIncome ? (
        <IncomeShape style={{ marginRight: '12px', flexShrink: 0 }} />
      ) : (
        <OutcomeShape style={{ marginRight: '12px', flexShrink: 0 }} />
      )}
      <div style={contentStyle}>
        <div style={titleWrapperStyle}>
          <b style={titleStyle}>{type}</b>
          <div>
            {source && <span style={subtitleStyle}>{source}</span>}
            {state &&
              tonTransactionData.type ===
                TonTransactionTypes.TYPE_WITHDRAWAL && (
                <span style={subtitleStyle}>{state}</span>
              )}
          </div>
        </div>
        <p style={timestampStyle}>
          {formatTransactionDate(tonTransactionData.update_time)}
        </p>
      </div>
      <div style={isIncome ? incomeAmountStyle : outcomeAmountStyle}>
        <span style={amountValueStyle}>{isIncome ? `+${amount}` : amount}</span>{' '}
        TON
      </div>
    </div>
  );
};

export default TonTransaction;
